<div class="success">
    <div class="succes-icon">
        <mat-icon>check</mat-icon>
    </div>
    <h2>Thank you for choosing <span>ELEKTRON</span> as your Partner.</h2>
    <h3>Let's embark on this journey together!</h3>
</div>